export default __webpack_public_path__ + "static/media/projects1.ac2a3c5f.jpg";